import React, { useEffect, useState } from 'react'
import { DPR_API } from '../../../../services/apiCalls/dprApiCalls';
import { SafetyStandard } from '../../../../assets/dpr';
import { toast } from 'react-toastify';
import { PROJECT_API } from '../../../../services/apiCalls/projectApiCalls';
import moment from 'moment';


export default function ObservationForm(props) {
    const [contractor, setContractor] = useState([]);
    const [reponsible, setReponsible] = useState([]);
    const [user, setUser] = useState("");


    const [observation, setObservation] = useState({
        "Id":"",
        "Name": user.Name,
        "LOID": "",
        "EmployeeID": "",
        "DateOfVisit": "",
        "ProjectID": props?.data?.project_id,
        "ProjectName": props?.data?.Project_Name,
        "DateOfObservation": "",
        "ProjectZoneRegion": "",
        "SiteNameLocation": "",
        "ObservationReportedBy": "",
        "IsContractorInvolved": "",
        "NameOfContractor": "",
        "ObservationDetails": "",
        "ObservationCategory": "",
        "SafetyStandard": "",
        "SeverityLevel": "",
        "ActionTaken": "",
        "ObservationStatus": "",
        "ResponsiblePerson": "",
        "TargetDateForCompliance": "",
        "ActualDateForCompliance": "",
        "ComplianceEvidence": "",
        "UserID": user?.user_id,
        "SiteNameLocation": "",
        "ProjectZoneRegion": ""
    });

    useEffect(()=>{
        console.log(props.updateDate)
        let data = observation;
        data=props.updateDate
        setObservation(data)

    },[])

     const fetMAx=async()=>{
        if(props.updateDate==null){
            const max=await DPR_API.MaxRow(1,0);
            if(max && max?.Status===200){
                let data = observation;
                data['LOID'] = "LOID-"+max?.MaxRow
                setObservation(data)
            }
        }  
        }

    useEffect(() => {
        fetMAx()
        const users = JSON.parse((localStorage.getItem("state")));
        let data = observation;
        data['Name'] = users?.user?.Name;
        data['UserID'] = users?.user?.user_id;
        data['SiteNameLocation'] = props?.data?.Location;
        data['ProjectZoneRegion'] = props?.data?.Region;
        data['EmployeeID'] = users?.user?.user_id
        if(props.updateDate!==null){
            let data = observation;
            if(props.updateDate?.IsContractorInvolved=="Yes"){
                let id1=document.getElementById("inlineRadio1")
                 id1.checked=true
            }
            if(props.updateDate?.IsContractorInvolved=="No"){
                let id1=document.getElementById("inlineRadio2")
                id1.checked=true
            }
          
            data['LOID']=props.updateDate?.LOID;
            data['ID']=props.updateDate?.ID;
            let obdate=moment(props.updateDate?.DateOfObservation).format("DD/MM/YYYY")
            console.log(obdate)
            data['DateOfObservation']=moment(props.updateDate?.DateOfObservation).format("YYYY-MM-DD")
            data['DateOfVisit']=moment(props.updateDate?.DateOfVisit).format("YYYY-MM-DD")
            data['ObservationReportedBy']=props.updateDate?.ObservationReportedBy
            data['IsContractorInvolved']=props.updateDate?.IsContractorInvolved
            data['NameOfContractor']=props.updateDate?.NameOfContractor
            data['ComplianceEvidence']=props.updateDate?.ComplianceEvidence
            data['ObservationDetails']=props.updateDate?.ObservationDetails
            data['ObservationCategory']=props.updateDate?.ObservationCategory
            data['SafetyStandard']=props.updateDate?.SafetyStandard
            data['SeverityLevel']=props.updateDate?.SeverityLevel
            data['ActionTaken']=props.updateDate?.ActionTaken
            data['ResponsiblePerson']=props.updateDate?.ResponsiblePerson
            data['TargetDateForCompliance']=moment(props.updateDate?.TargetDateForCompliance).format("YYYY-MM-DD")
            data['ActualDateForCompliance']=moment(props.updateDate?.ActualDateForCompliance).format("YYYY-MM-DD")
            data['ObservationStatus']=props.updateDate?.ObservationStatus
            setObservation(data)
        }
        setObservation(data)
        setUser(users?.user)
    }, [])

    const getContractor = async () => {
        const cons = await DPR_API.GetUserByRoleID({ "RoleID": "3" });
        const responsible = await DPR_API.GetUserByRoleID({ "RoleID": "2" });
        let data = cons?.UserResponseList.concat(responsible?.UserResponseList);
        setReponsible(data)
        setContractor(cons?.UserResponseList)
    }
    const handleChange = (event) => {
        const { name, value } = event.target;
        setObservation((prev) => ({ ...prev, [name]: value }));
    };
    useEffect(() => {
        getContractor();
    }, [])

    const validateIncident = (incident) => {
        // List of required fields
        const requiredFields = [
            "Name",
            "LOID",
            "EmployeeID",
            "DateOfVisit",
            "ProjectID",
            "ProjectName",
            "DateOfObservation",
            "ProjectZoneRegion",
            "SiteNameLocation",
            "ObservationReportedBy",
            "IsContractorInvolved",
            "NameOfContractor",
            "ObservationDetails",
            "ObservationCategory",
            "SafetyStandard",
            "SeverityLevel",
            "ActionTaken",
            "ObservationStatus",
            "ResponsiblePerson",
            "TargetDateForCompliance",
            "ActualDateForCompliance",
            "ComplianceEvidence",
            "UserID",
            "SiteNameLocation",
            "ProjectZoneRegion"
        ];
    
        // Check for empty fields
        const emptyFields = requiredFields.filter((field) => !incident[field]);
    
        if (emptyFields.length > 0) {
            const errorMessage = `The following fields are required: ${emptyFields.join(", ")}`;
            return { isValid: false, errorMessage };
        }
    
        return { isValid: true };
    };

    const onSubmit = async () => {
        const validation = validateIncident(observation);
        if (!validation.isValid) {
            toast.error("All fileds must be required",{ autoClose: 2000 });
            return;
        }

        const create = await DPR_API.Create_Update_Observation(observation);
        if (create && create?.Status == "200") {
            toast.success(create?.Message, { autoClose: 2000 })
            setTimeout(() => {
                props?.setSelectedIndex(0)
            }, 2100);
        }
    }
    const handleFile = async (e) => {
       const uploaded=await PROJECT_API?.saveDocument( e.target.files[0]);
       let data = observation;
       data['ComplianceEvidence'] = uploaded?uploaded?.fileUrl:"";
       setObservation(data)
    }
   

    return <React.Fragment>
        <div className='row mt-3'>
            <div className='col-3'>
                <label className='label-custom'>Name</label>
                <input disabled value={observation?.Name} onChange={handleChange} name='Name' type='text' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>LO ID</label>
                <input  disabled value={observation?.LOID} onChange={handleChange} name='LOID'  className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Employee ID</label>
                <input type='text' disabled value={observation?.EmployeeID} onChange={handleChange} name='EmployeeID' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Date of Visit</label>
                <input type='date' value={observation?.DateOfVisit} onChange={handleChange} name='DateOfVisit' className='form-control shadow-none' />
            </div>
        </div>
        <div className='row mt-2'>
            <div className='col-3'>
                <label className='label-custom'>Project Name</label>
                <input type='text' disabled value={observation?.ProjectName} onChange={handleChange} name='ProjectName' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Date of observation</label>
                <input type='date' value={observation?.DateOfObservation} onChange={handleChange} name='DateOfObservation' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Project Zone/Region</label>
                <input type='text' value={observation?.ProjectZoneRegion} onChange={handleChange} disabled name='ProjectZoneRegion' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Site Name /Location</label>
                <input type='text' value={observation?.SiteNameLocation} onChange={handleChange} disabled name='SiteNameLocation' className='form-control shadow-none' />
            </div>
        </div>
        <div className='row mt-2'>
            <div className='col-3'>
                <label className='label-custom'>Observation reported by</label>
                <input type='text' value={observation?.ObservationReportedBy} onChange={handleChange} name='ObservationReportedBy' className='form-control shadow-none' />
            </div>
            {/* <div className='col-3'>
                <label className='label-custom'>Date of observation</label>
                <input type='date' value={observation?.DateOfObservation} className='form-control shadow-none' />
            </div> */}
            <div className='col-3'>
                <label className='label-custom'>Is contractor involved in this incident</label>
                <div class="form-check form-check-inline">
                    <input value={"Yes"} onChange={(e) => {
                        let data = observation
                        data['IsContractorInvolved'] = e.target.value;
                        setObservation(data)
                    }} name="IsContractorInvolved"  class="form-check-input" type="radio" id="inlineRadio1" />
                    <label class="form-check-label" for="inlineRadio1">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" onChange={(e) => {
                        let data = observation
                        data['IsContractorInvolved'] = e.target.value;
                        setObservation(data)
                    }} value={"No"} name="IsContractorInvolved" type="radio" id="inlineRadio2" />
                    <label class="form-check-label" for="inlineRadio2">No</label>
                </div>
            </div>
            <div className='col-3'>
                <label className='label-custom'>Name of Contractor</label>
                <select value={observation?.NameOfContractor} onChange={handleChange} name='NameOfContractor' style={{
                    width: "100%",
                    height: 31,
                    border: "1px solid #e6e3e3",
                    borderRadius: 4,
                    color: 'gray',
                    fontSize: 13,
                    paddingLeft: 10
                }}>
                    <option value={""}>--Select--</option>
                    {contractor?.map(val => <option value={val?.ID}>{val?.Name}</option>)}
                </select>
            </div>
            <div className='col-3'>
                <label className='label-custom'>Compliance Evidence</label>
                <input type='file' accept="application/pdf" onChange={handleFile} id="ComplianceEvidence" className='form-control shadow-none' />
            </div>
        </div>
        <div className='row mt-2'>
            <div className='col-3'>
                <label className='label-custom'>Observation Details</label>
                <textarea value={observation?.ObservationDetails} onChange={handleChange} name='ObservationDetails' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Observation Category</label>
                <select value={observation?.ObservationCategory} onChange={handleChange} name='ObservationCategory' style={{
                    width: "100%",
                    height: 31,
                    border: "1px solid #e6e3e3",
                    borderRadius: 4,
                    color: 'gray',
                    fontSize: 13,
                    paddingLeft: 10
                }}>
                    <option value={""}>--Select--</option>
                    <option value={" Safe Act"}>
                        Safe Act
                    </option>
                    <option value={"Safe Condition"}>
                        Safe Condition
                    </option>
                    <option value={"Unsafe Act"}>
                        Unsafe Act
                    </option>
                    <option value={"Unsafe Condition"}>
                        Unsafe Condition
                    </option>

                </select>
            </div>
            <div className='col-3'>
                <label className='label-custom'>Safety Standard</label>
                <select value={observation?.SafetyStandard} onChange={handleChange} name='SafetyStandard' style={{
                    width: "100%",
                    height: 31,
                    border: "1px solid #e6e3e3",
                    borderRadius: 4,
                    color: 'gray',
                    fontSize: 13,
                    paddingLeft: 10
                }}>
                    <option>--Select--</option>
                    {
                        SafetyStandard?.data?.map(val => <option value={val}>
                            {val}
                        </option>)
                    }

                </select>
            </div>
            <div className='col-3'>
                <label className='label-custom'>Severity Level</label>
                <select value={observation?.SeverityLevel} onChange={handleChange} name='SeverityLevel' style={{
                    width: "100%",
                    height: 31,
                    border: "1px solid #e6e3e3",
                    borderRadius: 4,
                    color: 'gray',
                    fontSize: 13,
                    paddingLeft: 10
                }}>
                    <option value={""}>--Select--</option>
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                    <option value={6}>6</option>
                    <option value={7}>7</option>
                    <option value={8}>8</option>
                    <option value={9}>9</option>
                    <option value={10}>10</option>
                </select>
            </div>
        </div>
        <div className='row mt-2'>
            <div className='col-3'>
                <label className='label-custom'>Action Taken (Description)</label>
                <textarea value={observation?.ActionTaken} onChange={handleChange} name='ActionTaken' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Name of Responsible person (if observation
                    status is open)</label>
                <select value={observation?.ResponsiblePerson} onChange={handleChange} name='ResponsiblePerson' style={{
                    width: "100%",
                    height: 31,
                    border: "1px solid #e6e3e3",
                    borderRadius: 4,
                    color: 'gray',
                    fontSize: 13,
                    paddingLeft: 10
                }}>
                    <option>--Select--</option>
                    {reponsible?.map(val => <option value={val?.ID}>
                        {val?.Name}
                    </option>)}

                </select>
            </div>

            <div className='col-3'>
                <label className='label-custom'>Target Date for compliance</label>
                <input value={observation?.TargetDateForCompliance} onChange={handleChange} name='TargetDateForCompliance' type='date' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Actual Date for compliance</label>
                <input value={observation?.ActualDateForCompliance} onChange={handleChange} name='ActualDateForCompliance' type='date' className='form-control shadow-none' />
            </div>
        </div>

        <div className='row mt-2'>
            <div className='col-3'>
                <label className='label-custom'>Observation Status</label>
                <select value={observation?.ObservationStatus} onChange={handleChange} name='ObservationStatus' style={{
                    width: "100%",
                    height: 31,
                    border: "1px solid #e6e3e3",
                    borderRadius: 4,
                    color: 'gray',
                    fontSize: 13,
                    paddingLeft: 10
                }}>
                    <option value={""}>--Select--</option>
                    <option value={"Pending"}>Pending</option>
                    <option value={"Resolved"}>Resolved</option>
                </select>
            </div>
            <div className='col-1 mt-4'>
                <button className='btn btn-primary'
                    onClick={onSubmit}
                >Submit</button>
            </div>
            <div className='col-3 mt-4'>
                <button className='btn btn-danger'
                onClick={()=>{
                    props?.setSelectedIndex(0)
                }}
                >Cancel</button>
            </div>
        </div>

    </React.Fragment>
}
